// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__CFJf_","fullWidth":"style_fullWidth__2Bw2c"};